import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function MoneyBagIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M20.943 16.835a15.764 15.764 0 0 0-4.476-8.616c-.517-.503-.775-.754-1.346-.986C14.55 7 14.059 7 13.078 7h-2.156c-.981 0-1.472 0-2.043.233-.57.232-.83.483-1.346.986a15.764 15.764 0 0 0-4.476 8.616C2.57 19.773 5.28 22 8.308 22h7.384c3.029 0 5.74-2.227 5.25-5.165Z" />
      <path d="M7.257 4.443c-.207-.3-.506-.708.112-.8.635-.096 1.294.338 1.94.33.583-.009.88-.268 1.2-.638C10.845 2.946 11.365 2 12 2c.635 0 1.155.946 1.491 1.335.32.37.617.63 1.2.637.646.01 1.305-.425 1.94-.33.618.093.319.5.112.8l-.932 1.359c-.4.58-.599.87-1.017 1.035C14.377 7 13.837 7 12.758 7h-1.516c-1.08 0-1.619 0-2.036-.164-.418-.164-.617-.455-1.017-1.035l-.932-1.358Z" />
      <path d="M13.627 12.919c-.216-.799-1.317-1.519-2.638-.98-1.32.539-1.53 2.272.467 2.457.904.083 1.492-.097 2.031.412.54.508.64 1.923-.739 2.304-1.377.381-2.742-.214-2.89-1.06m1.984-5.06v.761m0 5.476v.764" />
    </SvgIcon>
  );
}
